
import {
  Component,
  Vue,
} from "@shared/node_modules/vue-property-decorator";
import CzMenu from "../menu/czmenu.vue";
import Footer from "@shared/components/footer/footer.vue";
import store from "@shared/core/store";
import { getContrastColorFromRGBA, parseRGBA } from "@shared/core/helpers/contrastColor";


@Component({
  components: {
    CzMenu,
    Footer,
  },
})
export default class InSecure extends Vue {
  private scrollY: number = 0;

  private get isHomePage(){
    return this.$route.name === 'index';
  }

  private get isDarkMode() {
    return store.state.settings.DarkMode === true;
  }

  private get showBtnHeader(){
    if(!this.isHomePage){
      return false;
    }
    return this.isHomePage && this.scrollY <= 30;
  }

  async mounted() {
    this.initializeTheme();
    window.addEventListener('scroll', this.handleScroll);
    if (this.isDarkMode) {
      this.generateBlobsByPageHeight(100);
      this.$nextTick(() => {
        this.generateBlobsByPageHeight(1000);
      });
    }
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  private handleScroll() {
    this.scrollY = window.scrollY;
  }

  initializeTheme(){
        const shared = store.state.settings;
    if (shared.ButtonsColor !== null && shared.ButtonsColor !== undefined) {
      document.documentElement.style.setProperty(
        "--main-color",
        shared.ButtonsColor
      );

      document.documentElement.style.setProperty(
        "--main-color-rgb",
        this.convertHexToRgb(shared.ButtonsColor)
      );

      const { r, g, b, a } = parseRGBA(shared.ButtonsColor);
      const contrast = getContrastColorFromRGBA(r, g, b, a);
      document.documentElement.style.setProperty("--main-contrast-color", contrast);
    }
    if (shared.FontFamily !== null && shared.FontFamily !== undefined) {
      document.documentElement.style.setProperty(
        "--main-family",
        shared.FontFamily
      );
    }

    if (shared.FooterColor !== null && shared.FooterColor !== undefined) {
      document.documentElement.style.setProperty(
        "--main-footercolor",
        shared.FooterColor
      );
    }

    const logo = shared.Uploads + "/" + shared.Mainlogo;
    var link: any = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = logo;
  }
  
  convertHexToRgb(hexadecimal) {
    let red, green, blue = 0; 
    if (hexadecimal.includes('rgb')) {
      hexadecimal = hexadecimal.replace('rgb', '').replace('(', '').replace(')', '');
      let color = hexadecimal.split(',');
      red = color[0];
      green = color[1];
      blue = color[2]; 
    } else {
      let hexColor = hexadecimal.replace("#", "");
      red = parseInt(hexColor.substring(0, 2), 16);
      green = parseInt(hexColor.substring(2, 4), 16);
      blue = parseInt(hexColor.substring(4, 6), 16); 
    }
    return `${red}, ${green}, ${blue}`;
  }
  
  generateBlobsByPageHeight(timeout: number) {
    setTimeout(() => {
      const container = this.$refs.blobsContainer as HTMLElement;
      if (!container) return;

       while (container.firstChild) {
        container.removeChild(container.firstChild);
      }

      const pageHeight = document.documentElement.scrollHeight;
      const firstTop = 100;
      const gap = 500;
      let index = 0;

      for (let top = firstTop; top < pageHeight + 600; top += gap) {
        const blob = document.createElement("div");
        blob.className = "blob";
        blob.style.top = `${top}px`;
        if (index % 2 === 0) {
          blob.style.left = "-50px";
        } else {
          blob.style.right = "-100px";
        }
        container.appendChild(blob);
        index++;
      }
    }, timeout);

  }
}
